import { Switch } from 'antd';
import FormField from 'components/FormField';
import { useTranslate } from '@tolgee/react';
import { FV } from './share';

function Enable({ editable = true }: { editable?: boolean }) {
  const { t } = useTranslate();

  return (
    <FormField<FV['enable']> required name="enable" label={t('aide.策略开关')}>
      {({ field: { value, onChange } }) => {
        return (
          <Switch
            disabled={!editable}
            checked={value}
            onChange={onChange}
            checkedChildren={t('aide.开')}
            unCheckedChildren={t('aide.关')}
          />
        );
      }}
    </FormField>
  );
}

export default Enable;
